export const config = {
    "name": "使用统计",
    "key": "useStatistics",
    "nav": [
        {
            "name": "单位",
            "tabKey": "0",
            "request": {
                "url": "/cm-sites-mmp/statistics/userDeptStaticsCount",
                "method": "get",
                "params": {
                    count: 10,
                    deptIds: 0,
                    endTime: 0,
                    offsite: 1,
                    sort: 0,
                    sortfield :"thumbsupCount",
                    startTime: 0,
                    type: 0
                },
                "defaultParams": {
                    count: 10,
                    deptIds: 0,
                    endTime: 0,
                    offsite: 1,
                    sort: 0,
                    sortfield :"thumbsupCount",
                    startTime: 0,
                    type: 0
                },
                "paramsConfig": {
                    size: "count",
                    page: "offsite",
                    sort: {
                        field: "sortfield",
                        order: {
                            key: "sort",
                            select: { "ascend": '1', "descend": '-1' }
                        },
                    },
                },
                "resConfig": {
                    count: "count",
                    data: "data"
                },
            },
            "renderSearch": {
                "searchConfig": [
                    [
                        {
                            "style": {
                                "float": "left"
                            },
                            "component": {
                                "name": "sta_Cascader",
                                "config": {
                                    style: {
                                        width: 224
                                    },
                                    searchPlaceholder: '请选择所属部门',
                                    treeId: "0",
                                    deleteRootNode: true,
                                    defaultValue: "0",
                                    clickCall: "onChange",
                                    formatConfig: {
                                        title: "name",
                                        key: "value",
                                        value: "lable",
                                        children: "child",
                                    },
                                    "request": {
                                        "url": "/cm-sites-sys/dept/getTree?id=0",
                                        "method": "get",
                                    },
                                    maxTagCount: 1
                                }
                            },
                            "placeholder": "请选择所属部门",
                            "disabled": false,
                            "id": "sta_dept",
                            "size": "default",
                            "labelCode": "deptIds",
                            "labelName": "请选择所属部门",
                            "defaultValue": "0",
                            "regStr": "",
                            "regMsg": ""
                        },
                        {
                            "style": {
                                "float": "left"
                            },
                            "component": {
                                "name": "sta_Button",
                                "config": {
                                    btnName: "查询",
                                    type: "primary",
                                    clickCall: "onSearch",
                                    style: {
                                        width: 64
                                    }
                                }
                            },
                            "disabled": false,
                            "id": "sta_searchBtn",
                            "size": "default",
                            "labelCode": "",
                        },
                        {
                            "style": {
                                "float": "left"
                            },
                            "component": {
                                "name": "sta_Button",
                                "config": {
                                    btnName: "重置",
                                    type: "default",
                                    clickCall: "onReset",
                                    noRestKey: ["startTime", "endTime"],
                                    style: {
                                        width: 64
                                    }
                                }
                            },
                            "disabled": false,
                            "id": "sta_searchBtn",
                            "size": "default",
                            "labelCode": "",
                        },
                    ],
                    [
                        {
                            "style": {
                                "float": "left"
                            },
                            "component": {
                                "name": "sta_Button",
                                "config": {
                                    btnName: "导出",
                                    type: "default",
                                    clickCall: "onExport",
                                    "request": {
                                        "url": "/cm-sites-mmp/statistics/userDeptStaticsCountExport",
                                        "method": "downloadGet",
                                        "params": {
                                            busName: "busNewsClue",
                                            pageSize: 9999
                                        },
                                    },
                                    style: {
                                        width: 64
                                    }
                                }
                            },
                            "disabled": false,
                            "id": "sta_searchBtn",
                            "size": "default",
                            "labelCode": "",
                        },
                        {
                            "style": {
                                "float": "right",
                                marginLeft: 'auto'
                            },
                            "component": {
                                "name": "sta_Date",
                                "config": {
                                    selectDateConfig: {
                                        defaultKey: "thisMonth",
                                        selectConfig: ["thisWeek", "lastWeek", "thisMonth", "lastMonth"]
                                    },
                                    onChangeCallFun: "onSearch",
                                    style: {
                                        width: 768
                                    }
                                }
                            },
                            "value:": "this.state.params.name",
                            "placeholder": "自定义日期范围",
                            "disabled": false,
                            "id": "sta_name",
                            "size": "default",
                            "labelCode": ["startTime", "endTime"],
                            "defaultValue": [null, null],
                            'sameDay':true,
                            "labelName": "",
                            "regStr": "",
                            "regMsg": ""
                        },
                    ]
                ]
            },
            "renderTable": {
                "defaultItemWidth": 200,
                "columns": [
                    {
                        "title": '部门名称',
                        "width": 100,
                        "dataIndex": 'deptName',
                        "key": 'deptName',
                    },
                    {
                        title: 'APP使用量',
                        dataIndex: 'useCount',
                        ellipsis: true,
                        sorter: true,
                        "width": 100,
                    },
                    {
                        title: '文章阅读总数',
                        dataIndex: 'viewCount',
                        ellipsis: true,
                        sorter: true,
                        "width": 100,
                    },
                    {
                        title: '文章点赞总数',
                        dataIndex: 'thumbsupCount',
                        ellipsis: true,
                        sorter: true,
                        "width": 100,

                    },
                    {
                        title: '文章分享总数',
                        dataIndex: 'retransmissionCount',
                        ellipsis: true,
                        sorter: true,
                        "width": 100,
                    },
                ]
            },
            "renderPage": {
                size: "middle",
                pageSizeOptions: ['10', '20', '30', '40']
            }
        },
        {
            "name": "个人",
            "tabKey": "1",
            "request": {
                "url": "/cm-sites-mmp/statistics/userDeptStaticsCount",
                "method": "get",
                "params": {
                    count: 10,
                    deptIds: 0,
                    endTime: 0,
                    offsite: 1,
                    sort: 0,
                    sortfield :"thumbsupCount",
                    startTime: 0,
                    type: 1
                },
                "defaultParams": {
                    count: 10,
                    deptIds: 0,
                    endTime: 0,
                    offsite: 1,
                    sort: 0,
                    sortfield :"thumbsupCount",
                    startTime: 0,
                    type: 1
                },
                "paramsConfig": {
                    size: "count",
                    page: "offsite",
                    sort: {
                        field: "sortfield",
                        order: {
                            key: "sort",
                            select: { "ascend": '1', "descend": '-1' }
                        },
                    },
                },
                "resConfig": {
                    count: "count",
                    data: "data"
                },
            },
            "renderSearch": {
                "searchConfig": [
                    [
                        {
                            "style": {
                                "float": "left"
                            },
                            "component": {
                                "name": "sta_Cascader",
                                "config": {
                                    style: {
                                        width: 224
                                    },
                                    searchPlaceholder: '请选择所属部门',
                                    treeId: '0',
                                    deleteRootNode: true,
                                    defaultValue: "0",
                                    clickCall: "onChange",
                                    formatConfig: {
                                        title: "name",
                                        key: "id",
                                        value: "id",
                                        children: "child",
                                    },
                                    "request": {
                                        "url": "/cm-sites-sys/dept/getTree?id=0",
                                        "method": "get",
                                    },
                                    maxTagCount: 1
                                }
                            },
                            "placeholder": "请选择所属部门",
                            "disabled": false,
                            "id": "sta_dept",
                            "size": "default",
                            "labelCode": "deptIds",
                            "labelName": "请选择所属部门",
                            "defaultValue": "0",
                            "regStr": "",
                            "regMsg": ""
                        },
                        {
                            "style": {
                                "float": "left"
                            },
                            "component": {
                                "name": "sta_Button",
                                "config": {
                                    btnName: "查询",
                                    type: "primary",
                                    clickCall: "onSearch",
                                    style: {
                                        width: 64
                                    }
                                }
                            },
                            "disabled": false,
                            "id": "sta_searchBtn",
                            "size": "default",
                            "labelCode": "",
                        },
                        {
                            "style": {
                                "float": "left"
                            },
                            "component": {
                                "name": "sta_Button",
                                "config": {
                                    btnName: "重置",
                                    type: "default",
                                    clickCall: "onReset",
                                    noRestKey: ["startTime", "endTime"],
                                    style: {
                                        width: 64
                                    }
                                }
                            },
                            "disabled": false,
                            "id": "sta_searchBtn",
                            "size": "default",
                            "labelCode": "",
                        },
                    ],
                    [
                        {
                            "style": {
                                "float": "left"
                            },
                            "component": {
                                "name": "sta_Button",
                                "config": {
                                    btnName: "导出",
                                    type: "default",
                                    clickCall: "onExport",
                                    "request": {
                                        "url": "/cm-sites-mmp/statistics/userDeptStaticsCountExport",
                                        "method": "downloadGet",
                                        "params": {
                                            busName: "busNewsClue",
                                            pageSize: 9999
                                        },
                                    },
                                    style: {
                                        width: 64
                                    }
                                }
                            },
                            "disabled": false,
                            "id": "sta_searchBtn",
                            "size": "default",
                            "labelCode": "",
                        },
                        {
                            "style": {
                                "float": "right",
                                marginLeft: 'auto'
                            },
                            "component": {
                                "name": "sta_Date",
                                "config": {
                                    selectDateConfig: {
                                        defaultKey: "thisMonth",
                                        selectConfig: ["thisWeek", "lastWeek", "thisMonth", "lastMonth"]
                                    },
                                    onChangeCallFun: "onSearch",
                                    style: {
                                        width: 768
                                    }
                                }
                            },
                            "value:": "this.state.params.name",
                            "placeholder": "自定义日期范围",
                            "disabled": false,
                            "id": "sta_name",
                            "size": "default",
                            "labelCode": ["startTime", "endTime"],
                            "defaultValue": [null, null],
                            "labelName": "",
                            "regStr": "",
                            "regMsg": ""
                        },
                    ]
                ]
            },
            "renderTable": {
                // 默认的每列宽度（即最小宽度）
                "defaultItemWidth": 100,
                "columns": [
                    {
                        "title": '部门名称',
                        "width": 100,
                        "dataIndex": 'deptName',
                        "key": 'deptName',
                    },
                    {
                        "title": '昵称',
                        "width": 100,
                        "dataIndex": 'userName',
                        "key": 'userName',
                    },
                    {
                        "title": '手机号',
                        "width": 100,
                        "dataIndex": 'phone',
                        "key": 'phone',
                    },
                    {
                        title: 'APP使用量',
                        dataIndex: 'useCount',
                        ellipsis: true,
                        sorter: true,
                        "width": 100,
                    },
                    {
                        title: '文章阅读总数',
                        dataIndex: 'viewCount',
                        ellipsis: true,
                        sorter: true,
                        "width": 100,
                    },
                    {
                        title: '文章点赞总数',
                        dataIndex: 'thumbsupCount',
                        ellipsis: true,
                        sorter: true,
                        "width": 100,

                    },
                    {
                        title: '文章分享总数',
                        dataIndex: 'retransmissionCount',
                        ellipsis: true,
                        sorter: true,
                        "width": 100,
                    },
                ]
            },
            "renderPage": {
                size: "middle",
                pageSizeOptions: ['10', '20', '30', '40']
            }
        },
    ]
};